import cn from "classnames";
import React from "react";
import styles from "./style.module.less";

export const CircleIcon = ({ active }: { active: boolean }): JSX.Element => (
    <svg className={cn({ [styles.circleIcon]: true, [styles.active]: active })} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4" cy="4" r="4" />
    </svg>
);
